import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { LocalStorage } from './local-storage.class';
import { Routenames } from './route-names.enum';
import { AuthorisationService } from './services/auth/authorisation.service';
import { Features } from './services/auth/features';
import { Functionalities } from './services/auth/functionalities';

/** Functionalities that give access to the project pages. */
export const projectAccess = [
    Functionalities.CustomerProjectsManage,
    Functionalities.CustomerProjectsParticipate,
    Functionalities.GeoManage,
];

export const projectOverviewAccess = [...projectAccess, Functionalities.GeoRestricted, Functionalities.GeoRead];

export const authGuard: CanActivateChildFn = () => {
    return LocalStorage.getUser() && LocalStorage.getUserToken()
        ? true
        : inject(Router).createUrlTree(['/', Routenames.login]);
};

export function requireAnyFunctionality(...functionalities: Functionalities[]): CanActivateFn {
    return () =>
        AuthorisationService.hasAnyFunctionality(functionalities) ? true : inject(Router).createUrlTree(['/']);
}

export function requireFeature(feature: Features): CanActivateFn {
    return () => (AuthorisationService.hasFeature(feature) ? true : inject(Router).createUrlTree(['/']));
}
